import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JazzHeader = _resolveComponent("JazzHeader")!
  const _component_JazzTitle = _resolveComponent("JazzTitle")!
  const _component_Background = _resolveComponent("Background")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_JazzFooter = _resolveComponent("JazzFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_JazzHeader),
    _createVNode(_component_JazzTitle),
    _createVNode(_component_Background),
    _createVNode(_component_router_view),
    _createVNode(_component_JazzFooter)
  ]))
}